import _toArray from '@babel/runtime/helpers/esm/toArray';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _get from '@babel/runtime/helpers/esm/get';
import { LitNotify } from '@morbidick/lit-element-notify';
import { css, property } from 'lit-element';
import { S as StripeBase, s as sharedStyles, b as bound, d as dash } from './shared.js';
import 'lit-html/directives/if-defined';
import '@babel/runtime/helpers/esm/defineProperty';
import '@typed/curry';
import 'lit-html';
import '@lavadrop/kebab-case';
import '@lavadrop/camel-case';
import '@pacote/memoize';

/* eslint-disable no-invalid-this */
function wrap(f) {
  return wrapped => {
    const {
      descriptor
    } = wrapped;
    const original = descriptor.value;
    descriptor.value = f(original);
    return { ...wrapped,
      descriptor
    };
  };
}

const stripeMethod = wrap(function (f) {
  const {
    name
  } = f;
  return async function (...args) {
    if (!this.stripe) throw new Error(`<${this.constructor.is}>: Stripe must be initialized before calling ${name}.`);
    return f.call(this, ...args).then(this.handleResponse);
  };
});

var style = css`:host {
  min-width: var(--stripe-elements-width, 300px);
  min-height: var(--stripe-elements-height, 50px);
}

#stripe {
  box-sizing: border-box;
  border-radius: var(--stripe-elements-border-radius, 4px);
  border: var(--stripe-elements-border, 1px solid transparent);
  box-shadow: var(--stripe-elements-box-shadow, 0 1px 3px 0 #e6ebf1);
  transition: var(--stripe-elements-transition, box-shadow 150ms ease);
  min-width: var(--stripe-elements-width, 300px);
  padding: var(--stripe-elements-element-padding, 8px 12px);
  background: var(--stripe-elements-element-background, white);
}

:host([focused]) #stripe {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

:host([error]) #stripe {
  border-color: #fa755a;
}
`;

function _decorate(decorators, factory, superClass, mixins) { var api = _getDecoratorsApi(); if (mixins) { for (var i = 0; i < mixins.length; i++) { api = mixins[i](api); } } var r = factory(function initialize(O) { api.initializeInstanceElements(O, decorated.elements); }, superClass); var decorated = api.decorateClass(_coalesceClassElements(r.d.map(_createElementDescriptor)), decorators); api.initializeClassElements(r.F, decorated.elements); return api.runClassFinishers(r.F, decorated.finishers); }

function _getDecoratorsApi() { _getDecoratorsApi = function () { return api; }; var api = { elementsDefinitionOrder: [["method"], ["field"]], initializeInstanceElements: function (O, elements) { ["method", "field"].forEach(function (kind) { elements.forEach(function (element) { if (element.kind === kind && element.placement === "own") { this.defineClassElement(O, element); } }, this); }, this); }, initializeClassElements: function (F, elements) { var proto = F.prototype; ["method", "field"].forEach(function (kind) { elements.forEach(function (element) { var placement = element.placement; if (element.kind === kind && (placement === "static" || placement === "prototype")) { var receiver = placement === "static" ? F : proto; this.defineClassElement(receiver, element); } }, this); }, this); }, defineClassElement: function (receiver, element) { var descriptor = element.descriptor; if (element.kind === "field") { var initializer = element.initializer; descriptor = { enumerable: descriptor.enumerable, writable: descriptor.writable, configurable: descriptor.configurable, value: initializer === void 0 ? void 0 : initializer.call(receiver) }; } Object.defineProperty(receiver, element.key, descriptor); }, decorateClass: function (elements, decorators) { var newElements = []; var finishers = []; var placements = { static: [], prototype: [], own: [] }; elements.forEach(function (element) { this.addElementPlacement(element, placements); }, this); elements.forEach(function (element) { if (!_hasDecorators(element)) return newElements.push(element); var elementFinishersExtras = this.decorateElement(element, placements); newElements.push(elementFinishersExtras.element); newElements.push.apply(newElements, elementFinishersExtras.extras); finishers.push.apply(finishers, elementFinishersExtras.finishers); }, this); if (!decorators) { return { elements: newElements, finishers: finishers }; } var result = this.decorateConstructor(newElements, decorators); finishers.push.apply(finishers, result.finishers); result.finishers = finishers; return result; }, addElementPlacement: function (element, placements, silent) { var keys = placements[element.placement]; if (!silent && keys.indexOf(element.key) !== -1) { throw new TypeError("Duplicated element (" + element.key + ")"); } keys.push(element.key); }, decorateElement: function (element, placements) { var extras = []; var finishers = []; for (var decorators = element.decorators, i = decorators.length - 1; i >= 0; i--) { var keys = placements[element.placement]; keys.splice(keys.indexOf(element.key), 1); var elementObject = this.fromElementDescriptor(element); var elementFinisherExtras = this.toElementFinisherExtras((0, decorators[i])(elementObject) || elementObject); element = elementFinisherExtras.element; this.addElementPlacement(element, placements); if (elementFinisherExtras.finisher) { finishers.push(elementFinisherExtras.finisher); } var newExtras = elementFinisherExtras.extras; if (newExtras) { for (var j = 0; j < newExtras.length; j++) { this.addElementPlacement(newExtras[j], placements); } extras.push.apply(extras, newExtras); } } return { element: element, finishers: finishers, extras: extras }; }, decorateConstructor: function (elements, decorators) { var finishers = []; for (var i = decorators.length - 1; i >= 0; i--) { var obj = this.fromClassDescriptor(elements); var elementsAndFinisher = this.toClassDescriptor((0, decorators[i])(obj) || obj); if (elementsAndFinisher.finisher !== undefined) { finishers.push(elementsAndFinisher.finisher); } if (elementsAndFinisher.elements !== undefined) { elements = elementsAndFinisher.elements; for (var j = 0; j < elements.length - 1; j++) { for (var k = j + 1; k < elements.length; k++) { if (elements[j].key === elements[k].key && elements[j].placement === elements[k].placement) { throw new TypeError("Duplicated element (" + elements[j].key + ")"); } } } } } return { elements: elements, finishers: finishers }; }, fromElementDescriptor: function (element) { var obj = { kind: element.kind, key: element.key, placement: element.placement, descriptor: element.descriptor }; var desc = { value: "Descriptor", configurable: true }; Object.defineProperty(obj, Symbol.toStringTag, desc); if (element.kind === "field") obj.initializer = element.initializer; return obj; }, toElementDescriptors: function (elementObjects) { if (elementObjects === undefined) return; return _toArray(elementObjects).map(function (elementObject) { var element = this.toElementDescriptor(elementObject); this.disallowProperty(elementObject, "finisher", "An element descriptor"); this.disallowProperty(elementObject, "extras", "An element descriptor"); return element; }, this); }, toElementDescriptor: function (elementObject) { var kind = String(elementObject.kind); if (kind !== "method" && kind !== "field") { throw new TypeError('An element descriptor\'s .kind property must be either "method" or' + ' "field", but a decorator created an element descriptor with' + ' .kind "' + kind + '"'); } var key = _toPropertyKey(elementObject.key); var placement = String(elementObject.placement); if (placement !== "static" && placement !== "prototype" && placement !== "own") { throw new TypeError('An element descriptor\'s .placement property must be one of "static",' + ' "prototype" or "own", but a decorator created an element descriptor' + ' with .placement "' + placement + '"'); } var descriptor = elementObject.descriptor; this.disallowProperty(elementObject, "elements", "An element descriptor"); var element = { kind: kind, key: key, placement: placement, descriptor: Object.assign({}, descriptor) }; if (kind !== "field") { this.disallowProperty(elementObject, "initializer", "A method descriptor"); } else { this.disallowProperty(descriptor, "get", "The property descriptor of a field descriptor"); this.disallowProperty(descriptor, "set", "The property descriptor of a field descriptor"); this.disallowProperty(descriptor, "value", "The property descriptor of a field descriptor"); element.initializer = elementObject.initializer; } return element; }, toElementFinisherExtras: function (elementObject) { var element = this.toElementDescriptor(elementObject); var finisher = _optionalCallableProperty(elementObject, "finisher"); var extras = this.toElementDescriptors(elementObject.extras); return { element: element, finisher: finisher, extras: extras }; }, fromClassDescriptor: function (elements) { var obj = { kind: "class", elements: elements.map(this.fromElementDescriptor, this) }; var desc = { value: "Descriptor", configurable: true }; Object.defineProperty(obj, Symbol.toStringTag, desc); return obj; }, toClassDescriptor: function (obj) { var kind = String(obj.kind); if (kind !== "class") { throw new TypeError('A class descriptor\'s .kind property must be "class", but a decorator' + ' created a class descriptor with .kind "' + kind + '"'); } this.disallowProperty(obj, "key", "A class descriptor"); this.disallowProperty(obj, "placement", "A class descriptor"); this.disallowProperty(obj, "descriptor", "A class descriptor"); this.disallowProperty(obj, "initializer", "A class descriptor"); this.disallowProperty(obj, "extras", "A class descriptor"); var finisher = _optionalCallableProperty(obj, "finisher"); var elements = this.toElementDescriptors(obj.elements); return { elements: elements, finisher: finisher }; }, runClassFinishers: function (constructor, finishers) { for (var i = 0; i < finishers.length; i++) { var newConstructor = (0, finishers[i])(constructor); if (newConstructor !== undefined) { if (typeof newConstructor !== "function") { throw new TypeError("Finishers must return a constructor."); } constructor = newConstructor; } } return constructor; }, disallowProperty: function (obj, name, objectType) { if (obj[name] !== undefined) { throw new TypeError(objectType + " can't have a ." + name + " property."); } } }; return api; }

function _createElementDescriptor(def) { var key = _toPropertyKey(def.key); var descriptor; if (def.kind === "method") { descriptor = { value: def.value, writable: true, configurable: true, enumerable: false }; } else if (def.kind === "get") { descriptor = { get: def.value, configurable: true, enumerable: false }; } else if (def.kind === "set") { descriptor = { set: def.value, configurable: true, enumerable: false }; } else if (def.kind === "field") { descriptor = { configurable: true, writable: true, enumerable: true }; } var element = { kind: def.kind === "field" ? "field" : "method", key: key, placement: def.static ? "static" : def.kind === "field" ? "own" : "prototype", descriptor: descriptor }; if (def.decorators) element.decorators = def.decorators; if (def.kind === "field") element.initializer = def.value; return element; }

function _coalesceGetterSetter(element, other) { if (element.descriptor.get !== undefined) { other.descriptor.get = element.descriptor.get; } else { other.descriptor.set = element.descriptor.set; } }

function _coalesceClassElements(elements) { var newElements = []; var isSameElement = function (other) { return other.kind === "method" && other.key === element.key && other.placement === element.placement; }; for (var i = 0; i < elements.length; i++) { var element = elements[i]; var other; if (element.kind === "method" && (other = newElements.find(isSameElement))) { if (_isDataDescriptor(element.descriptor) || _isDataDescriptor(other.descriptor)) { if (_hasDecorators(element) || _hasDecorators(other)) { throw new ReferenceError("Duplicated methods (" + element.key + ") can't be decorated."); } other.descriptor = element.descriptor; } else { if (_hasDecorators(element)) { if (_hasDecorators(other)) { throw new ReferenceError("Decorators can't be placed on different accessors with for " + "the same property (" + element.key + ")."); } other.decorators = element.decorators; } _coalesceGetterSetter(element, other); } } else { newElements.push(element); } } return newElements; }

function _hasDecorators(element) { return element.decorators && element.decorators.length; }

function _isDataDescriptor(desc) { return desc !== undefined && !(desc.value === undefined && desc.writable === undefined); }

function _optionalCallableProperty(obj, name) { var value = obj[name]; if (value !== undefined && typeof value !== "function") { throw new TypeError("Expected '" + name + "' to be a function"); } return value; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const allowedStyles = ['color', 'fontFamily', 'fontSize', 'fontStyle', 'fontSmoothing', 'fontVariant', 'iconColor', 'lineHeight', 'letterSpacing', 'textDecoration', 'textShadow', 'textTransform'];
/**
 * [Stripe.js v3 Card Elements](https://stripe.com/docs/elements), but it's a Web Component!
 * Supports Shadow DOM.
 *
 * 👨‍🎨 [Live Demo](https://bennypowers.dev/stripe-elements/?path=/docs/stripe-elements--enter-a-stripe-publishable-key) 👀
 *
 * ### 🧙‍♂️ Usage
 * If you prebuilt with Snowpack, load the module from your `web_modules` directory
 *
 * ```html
 * <script type="module" src="/web_modules/@power-elements/stripe-elements/stripe-elements.js"></script>
 * ```
 *
 * Alternatively, load the module from the unpkg CDN
 * ```html
 * <script type="module" src="https://unpkg.com/@power-elements/stripe-elements/stripe-elements.js?module"></script>
 * ```
 *
 * Then you can add the element to your page.
 *
 * ```html
 * <stripe-elements id="stripe"
 *     action="/payment"
 *     publishable-key="pk_test_XXXXXXXXXXXXXXXXXXXXXXXX"
 * ></stripe-elements>
 * ```
 *
 * See the demos for more comprehensive examples.
 *   - Using `<stripe-elements>` with [plain HTML and JavaScript](https://bennypowers.dev/stripe-elements/?path=/docs/framework-examples-html--stripe-elements).
 *   - Using `<stripe-elements>` in a [LitElement](https://bennypowers.dev/stripe-elements/?path=/docs/framework-examples-litelement--stripe-elements).
 *   - Using `<stripe-elements>` in a [Vue Component](https://bennypowers.dev/stripe-elements/?path=/docs/framework-examples-vue--stripe-elements).
 *   - Using `<stripe-elements>` in an [Angular component](https://bennypowers.dev/stripe-elements/?path=/docs/framework-examples-angular--stripe-elements).
 *   - Using `<stripe-elements>` in a [React component](https://bennypowers.dev/stripe-elements/?path=/docs/framework-examples-react--stripe-elements).
 *   - Using `<stripe-elements>` in a [Preact component](https://bennypowers.dev/stripe-elements/?path=/docs/framework-examples-preact--stripe-elements).
 *
 * ## Styling
 *
 * Stripe v3's 'Stripe Elements' are not custom elements, but rather forms
 * hosted by stripe and injected into your page via an iFrame. When we refer to the
 * 'Stripe Element' in this document, we are referring to the hosted Stripe form,
 * not the `<stripe-element>` custom element. But when I mention the 'element', I mean the custom element.
 *
 * When you apply CSS to the custom properties available, they're parsed and sent to Stripe, who should apply them to the Stripe Element they return in the iFrame.
 *
 * - `base` styles are inherited by all other variants.
 * - `complete` styles are applied when the Stripe Element has valid input.
 * - `empty` styles are applied when the Stripe Element has no user input.
 * - `invalid` styles are applied when the Stripe Element has invalid input.
 *
 * There are 11 properties for each state that you can set which will be read into the Stripe Element iFrame:
 *
 * - `color`
 * - `font-family`
 * - `font-size`
 * - `font-smoothing`
 * - `font-variant`
 * - `icon-color`
 * - `line-height`
 * - `letter-spacing`
 * - `text-decoration`
 * - `text-shadow`
 * - `text-transform`
 *
 * @cssprop [--stripe-elements-border-radius] - border radius of the element container. Default `4px`
 * @cssprop [--stripe-elements-border] - border property of the element container. Default `1px solid transparent`
 * @cssprop [--stripe-elements-box-shadow] - box shadow for the element container. Default `0 1px 3px 0 #e6ebf1`
 * @cssprop [--stripe-elements-transition] - transition property for the element container. Default `box-shadow 150ms ease`
 *
 * @cssprop [--stripe-elements-base-color] - `color` property for the element in its base state
 * @cssprop [--stripe-elements-base-font-family] - `font-family` property for the element in its base state
 * @cssprop [--stripe-elements-base-font-size] - `font-size` property for the element in its base state
 * @cssprop [--stripe-elements-base-font-smoothing] - `font-smoothing` property for the element in its base state
 * @cssprop [--stripe-elements-base-font-variant] - `font-variant` property for the element in its base state
 * @cssprop [--stripe-elements-base-icon-color] - `icon-color` property for the element in its base state
 * @cssprop [--stripe-elements-base-line-height] - `line-height` property for the element in its base state
 * @cssprop [--stripe-elements-base-letter-spacing] - `letter-spacing` property for the element in its base state
 * @cssprop [--stripe-elements-base-text-decoration] - `text-decoration` property for the element in its base state
 * @cssprop [--stripe-elements-base-text-shadow] - `text-shadow` property for the element in its base state
 * @cssprop [--stripe-elements-base-text-transform] - `text-transform` property for the element in its base state
 *
 * @cssprop [--stripe-elements-complete-color] - `color` property for the element in its complete state
 * @cssprop [--stripe-elements-complete-font-family] - `font-family` property for the element in its complete state
 * @cssprop [--stripe-elements-complete-font-size] - `font-size` property for the element in its complete state
 * @cssprop [--stripe-elements-complete-font-smoothing] - `font-smoothing` property for the element in its complete state
 * @cssprop [--stripe-elements-complete-font-variant] - `font-variant` property for the element in its complete state
 * @cssprop [--stripe-elements-complete-icon-color] - `icon-color` property for the element in its complete state
 * @cssprop [--stripe-elements-complete-line-height] - `line-height` property for the element in its complete state
 * @cssprop [--stripe-elements-complete-letter-spacing] - `letter-spacing` property for the element in its complete state
 * @cssprop [--stripe-elements-complete-text-decoration] - `text-decoration` property for the element in its complete state
 * @cssprop [--stripe-elements-complete-text-shadow] - `text-shadow` property for the element in its complete state
 * @cssprop [--stripe-elements-complete-text-transform] - `text-transform` property for the element in its complete state
 *
 * @cssprop [--stripe-elements-empty-color] - `color` property for the element in its empty state
 * @cssprop [--stripe-elements-empty-font-family] - `font-family` property for the element in its empty state
 * @cssprop [--stripe-elements-empty-font-size] - `font-size` property for the element in its empty state
 * @cssprop [--stripe-elements-empty-font-smoothing] - `font-smoothing` property for the element in its empty state
 * @cssprop [--stripe-elements-empty-font-variant] - `font-variant` property for the element in its empty state
 * @cssprop [--stripe-elements-empty-icon-color] - `icon-color` property for the element in its empty state
 * @cssprop [--stripe-elements-empty-line-height] - `line-height` property for the element in its empty state
 * @cssprop [--stripe-elements-empty-letter-spacing] - `letter-spacing` property for the element in its empty state
 * @cssprop [--stripe-elements-empty-text-decoration] - `text-decoration` property for the element in its empty state
 * @cssprop [--stripe-elements-empty-text-shadow] - `text-shadow` property for the element in its empty state
 * @cssprop [--stripe-elements-empty-text-transform] - `text-transform` property for the element in its empty state
 *
 * @cssprop [--stripe-elements-invalid-color] - `color` property for the element in its invalid state
 * @cssprop [--stripe-elements-invalid-font-family] - `font-family` property for the element in its invalid state
 * @cssprop [--stripe-elements-invalid-font-size] - `font-size` property for the element in its invalid state
 * @cssprop [--stripe-elements-invalid-font-smoothing] - `font-smoothing` property for the element in its invalid state
 * @cssprop [--stripe-elements-invalid-font-variant] - `font-variant` property for the element in its invalid state
 * @cssprop [--stripe-elements-invalid-icon-color] - `icon-color` property for the element in its invalid state
 * @cssprop [--stripe-elements-invalid-line-height] - `line-height` property for the element in its invalid state
 * @cssprop [--stripe-elements-invalid-letter-spacing] - `letter-spacing` property for the element in its invalid state
 * @cssprop [--stripe-elements-invalid-text-decoration] - `text-decoration` property for the element in its invalid state
 * @cssprop [--stripe-elements-invalid-text-shadow] - `text-shadow` property for the element in its invalid state
 * @cssprop [--stripe-elements-invalid-text-transform] - `text-transform` property for the element in its invalid state
 *
 * @element stripe-elements
 * @extends StripeBase
 *
 * @fires 'change' - Stripe Element change event
 */

let StripeElements = _decorate(null, function (_initialize, _LitNotify) {
  class StripeElements extends _LitNotify {
    constructor(...args) {
      super(...args);

      _initialize(this);
    }

  }

  return {
    F: StripeElements,
    d: [{
      kind: "field",
      static: true,
      key: "is",

      value() {
        return 'stripe-elements';
      }

    }, {
      kind: "field",
      static: true,
      key: "elementType",

      value() {
        return 'card';
      }

    }, {
      kind: "field",
      static: true,
      key: "styles",

      value() {
        return [sharedStyles, style];
      }

    }, {
      kind: "field",
      decorators: [property({
        type: Boolean,
        attribute: 'hide-icon'
      })],
      key: "hideIcon",

      value() {
        return false;
      }

    }, {
      kind: "field",
      decorators: [property({
        type: Boolean,
        attribute: 'hide-postal-code'
      })],
      key: "hidePostalCode",

      value() {
        return false;
      }

    }, {
      kind: "field",
      decorators: [property({
        type: String,
        attribute: 'icon-style'
      })],
      key: "iconStyle",

      value() {
        return 'default';
      }

    }, {
      kind: "field",
      decorators: [property({
        type: Object
      })],
      key: "value",

      value() {
        return {};
      }

    }, {
      kind: "field",
      decorators: [property({
        type: String,
        notify: true,
        readOnly: true
      })],
      key: "brand",

      value() {
        return null;
      }

    }, {
      kind: "field",
      decorators: [property({
        type: Boolean,
        reflect: true,
        notify: true,
        readOnly: true
      })],
      key: "complete",

      value() {
        return false;
      }

    }, {
      kind: "field",
      decorators: [property({
        type: Boolean,
        reflect: true,
        notify: true,
        readOnly: true
      })],
      key: "empty",

      value() {
        return true;
      }

    }, {
      kind: "field",
      decorators: [property({
        type: Boolean,
        reflect: true,
        notify: true,
        readOnly: true
      })],
      key: "invalid",

      value() {
        return false;
      }

    }, {
      kind: "field",
      decorators: [property({
        type: Object,
        notify: true,
        readOnly: true
      })],
      key: "card",

      value() {
        return null;
      }

    }, {
      kind: "field",
      decorators: [property({
        type: Boolean,
        attribute: 'is-empty',
        reflect: true,
        notify: true,
        readOnly: true
      })],
      key: "isEmpty",

      value() {
        return true;
      }

    }, {
      kind: "field",
      decorators: [property({
        type: Boolean,
        attribute: 'is-complete',
        reflect: true,
        notify: true,
        readOnly: true
      })],
      key: "isComplete",

      value() {
        return false;
      }

    }, {
      kind: "method",
      key: "updated",
      value:
      /* PUBLIC FIELDS */

      /**
       * Whether to hide icons in the Stripe form.
       * @type {boolean}
       */

      /**
       * Whether or not to hide the postal code field.
       * Useful when you gather shipping info elsewhere.
       * @type {boolean}
       */

      /**
       * Stripe icon style. 'solid' or 'default'.
       * @type {'solid'|'default'}
       */

      /**
       * Prefilled values for form. Example {postalCode: '90210'}
       * @type {object}
       */

      /* READ ONLY PROPERTIES */

      /**
       * The card brand detected by Stripe
       * @type {string}
       * @readonly
       */

      /**
       * Whether the form is complete.
       * @type {boolean}
       * @readonly
       */

      /**
       * If the form is empty.
       * @type {boolean}
       * @readonly
       */

      /**
       * Whether the form is invalid.
       * @type {boolean}
       * @readonly
       */
      // DEPRECATED

      /**
       * The Stripe card object.
       * **DEPRECATED**. Will be removed in a future version. use `element` instead
       * @type {stripe.elements.Element}
       * @readonly
       * @deprecated
       */

      /**
       * Whether the form is empty.
       * **DEPRECATED**. Will be removed in a future version. use `empty` instead
       * @type {boolean}
       * @deprecated
       */

      /**
       * Whether the form is complete.
       * **DEPRECATED**. Will be removed in a future version. use `complete` instead
       * @type {boolean}
       * @deprecated
       */
      function updated(changed) {
        _get(_getPrototypeOf(StripeElements.prototype), "updated", this).call(this, changed); // DEPRECATED


        if (changed.has('element') && !this.element) this.set({
          card: null
        });
      }
      /* PUBLIC API */

      /**
       * Submit payment information to generate a paymentMethod
       * @param {stripe.PaymentMethodData} [paymentMethodData={}]
       * @resolves {stripe.PaymentMethodResponse}
       */

    }, {
      kind: "method",
      decorators: [stripeMethod],
      key: "createPaymentMethod",
      value: async function createPaymentMethod(paymentMethodData = this.getPaymentMethodData()) {
        return this.stripe.createPaymentMethod(paymentMethodData);
      }
      /**
       * Submit payment information to generate a source
       * @param {{ owner: stripe.OwnerInfo }} [sourceData={}]
       * @resolves {stripe.SourceResponse}
       */

    }, {
      kind: "method",
      decorators: [stripeMethod],
      key: "createSource",
      value: async function createSource(sourceData = this.sourceData) {
        return this.stripe.createSource(this.element, sourceData);
      }
      /**
       * Submit payment information to generate a token
       * @param {TokenData} [tokenData=this.tokenData]
       * @resolves {stripe.TokenResponse}
       */

    }, {
      kind: "method",
      decorators: [stripeMethod],
      key: "createToken",
      value: async function createToken(tokenData = this.tokenData) {
        return this.stripe.createToken(this.element, tokenData);
      }
      /**
       * Checks for potential validity. A potentially valid form is one that is not empty, not complete and has no error. A validated form also counts as potentially valid.
       * @return {boolean} true if the Stripe form is potentially valid
       */

    }, {
      kind: "method",
      key: "isPotentiallyValid",
      value: function isPotentiallyValid() {
        return !this.complete && !this.empty && !this.error || this.validate();
      }
      /**
       * Resets the Stripe card.
       */

    }, {
      kind: "method",
      key: "reset",
      value: function reset() {
        var _this$element;

        _get(_getPrototypeOf(StripeElements.prototype), "reset", this).call(this);

        (_this$element = this.element) === null || _this$element === void 0 ? void 0 : _this$element.clear();
      }
      /**
       * Generates a payment representation of the type specified by `generate`.
       * @resolves {PaymentResponse}
       */

    }, {
      kind: "method",
      key: "submit",
      value: async function submit() {
        switch (this.generate) {
          case 'payment-method':
            return this.createPaymentMethod();

          case 'source':
            return this.createSource();

          case 'token':
            return this.createToken();

          default:
            {
              const error = this.createError(`cannot generate ${this.generate}`);
              await this.set({
                error
              });
              throw error;
            }
        }
      }
      /**
       * Checks if the Stripe form is valid.
       * @return {boolean} true if the Stripe form is valid
       */

    }, {
      kind: "method",
      key: "validate",
      value: function validate() {
        const {
          complete,
          empty,
          error
        } = this;
        const isValid = !error && complete && !empty;
        if (empty && !error) this.set({
          error: this.createError('Your card number is empty.')
        });
        return isValid;
      }
      /* PRIVATE METHODS */

      /**
       * Generates PaymentMethodData from the element.
       * @param  {stripe.PaymentMethodData} data data, minus card property
       * @return {stripe.PaymentMethodData} data with card property
       * @private
       */

    }, {
      kind: "method",
      key: "getPaymentMethodData",
      value: function getPaymentMethodData() {
        const type = 'card';
        const {
          billingDetails,
          element: card,
          paymentMethodData
        } = this;
        return {
          billing_details: billingDetails,
          ...paymentMethodData,
          type,
          card
        };
      }
      /**
       * Returns a Stripe-friendly style object computed from CSS custom properties
       * @return {StripeStyleInit} Stripe Style initialization object.
       * @private
       */

    }, {
      kind: "method",
      key: "getStripeElementsStyles",
      value: function getStripeElementsStyles() {
        const computedStyle = window.ShadyCSS ? undefined : getComputedStyle(this);

        const getStyle = prop => this.getCSSCustomPropertyValue(prop, computedStyle) || undefined;

        const styleReducer = ({
          base = {},
          complete = {},
          empty = {},
          invalid = {}
        }, camelCase) => ({
          base: { ...base,
            [camelCase]: getStyle(`--stripe-elements-base-${dash(camelCase)}`)
          },
          complete: { ...complete,
            [camelCase]: getStyle(`--stripe-elements-complete-${dash(camelCase)}`)
          },
          empty: { ...empty,
            [camelCase]: getStyle(`--stripe-elements-empty-${dash(camelCase)}`)
          },
          invalid: { ...invalid,
            [camelCase]: getStyle(`--stripe-elements-invalid-${dash(camelCase)}`)
          }
        });

        return allowedStyles.reduce(styleReducer, {});
      }
      /**
       * @private
       */

    }, {
      kind: "method",
      key: "initElement",
      value: async function initElement() {
        if (!this.stripe) return;
        const {
          hidePostalCode,
          hideIcon,
          iconStyle,
          value
        } = this;
        const style = this.getStripeElementsStyles();
        const options = {
          hideIcon,
          hidePostalCode,
          iconStyle,
          style,
          value
        };
        const element = this.elements.create('card', options);
        element.addEventListener('change', this.onChange);
        await this.set({
          element,
          // DEPRECATED
          card: element
        });
      }
      /**
       * Updates the element's state.
       * @param  {stripe.elements.ElementChangeResponse}         event
       * @param  {boolean}       event.empty     true if value is empty
       * @param  {boolean}       event.complete  true if value is well-formed and potentially complete.
       * @param  {string}        event.brand     brand of the card being entered e.g. 'visa' or 'amex'
       * @param  {stripe.Error}  event.error     The current validation error, if any.
       * @param  {String|Object} event.value     Value of the form. Only non-sensitive information e.g. postalCode is present.
       * @private
       */

    }, {
      kind: "method",
      decorators: [bound],
      key: "onChange",
      value: async function onChange(event) {
        const {
          brand,
          complete,
          empty,
          error = null
        } = event;
        const invalid = error || !empty && !complete;
        await this.set({
          brand,
          complete,
          empty,
          error,
          invalid,
          // DEPRECATED
          isComplete: complete,
          isEmpty: empty
        });
        this.fire('change', event); // DEPRECATED

        this.fire('stripe-change', event);
      }
    }]
  };
}, LitNotify(StripeBase));
/** @typedef {{ base?: stripe.elements.Style, complete?: stripe.elements.Style, empty?: stripe.elements.Style, invalid?: stripe.elements.Style}} StripeStyleInit */

customElements.define(StripeElements.is, StripeElements);

export { StripeElements };
//# sourceMappingURL=stripe-elements.js.map
